/*
 * @Description: 输入框组件
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-22 19:35:05
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2021-12-01 21:10:32
 */

import classnames from 'classnames';
import React from 'react';

import './Input.less';
export interface IInput {
  name: string;
  children?: React.ReactNode;
  register: any;
  placeholder: string;
  style?: React.CSSProperties;
  registerOptions?: Record<string, any>;
  error?: boolean;
  handleBlurChange?: () => void;
}

export const Input = (props: IInput): React.ReactElement => {
  const { name, register, children, placeholder, style, error, registerOptions = {}, handleBlurChange } = props;

  return (
    <div className={classnames('form-input', { error })}>
      <input
        ref={register(registerOptions)}
        name={name}
        autoComplete="off"
        className="input"
        placeholder={placeholder}
        style={style}
        onBlur={handleBlurChange}
      />
      {children}
    </div>
  );
};


